import type { Chord } from 'svguitar';

export const GChords: Record<string, Chord> = {
  G: {
    fingers: [
      [1, 3, '4'],
      [2, 3, '3'],
      [5, 2, '1'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'G',
    position: 0,
  },
  'G/B': {
    fingers: [
      [1, 3, '4'],
      [2, 3, '3'],
      [5, 2, { text: '2', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'G/B',
    position: 0,
  },
  G7: {
    fingers: [
      [1, 1, '1'],
      [2, 3, '2'],
      [5, 2, '3'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'G7',
    position: 0,
  },
  G9: {
    fingers: [
      [1, 'x'],
      [2, 3, '3'],
      [3, 2, '1'],
      [5, 'x'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'G9',
    position: 0,
  },
  Gma7: {
    fingers: [
      [1, 2, '1'],
      [2, 3, '3'],
      [3, 0],
      [5, 'x'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'Gma7',
    position: 0,
  },
  GM7: {
    fingers: [
      [1, 2, '1'],
      [2, 3, '3'],
      [3, 0],
      [5, 'x'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'GM7',
    position: 0,
  },
  Gm: {
    fingers: [
      [4, 4, '3'],
      [5, 4, '2'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Gm',
    position: 2,
  },
  Gm7: {
    fingers: [[5, 4, '2']],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Gm7',
    position: 2,
  },
};
